import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "./App.css";
import Router from "./routes/Router";
import {
  fetchAndPatchMandateSession,
  fetchAndStoreMandateSession,
} from "./util/fetchAndStoreMandate";
import { MANDATE_STALE_MS } from "./util/mandateSessionStorage";
import { waitForScreenApisIdle } from "./util/pendingApiTracker";

const App = () => {
  const dispatch = useDispatch();
  const refreshTimerRef = useRef(null);
  // Hold Router until data-sharing finishes so it runs before screen APIs
  const [dataSharingReady, setDataSharingReady] = useState(
    () => !localStorage.getItem("accessToken"),
  );

  useEffect(() => {
    const clearRefreshTimer = () => {
      if (refreshTimerRef.current != null) {
        clearTimeout(refreshTimerRef.current);
        refreshTimerRef.current = null;
      }
    };

    const scheduleNextFullMandateFetch = () => {
      if (!localStorage.getItem("accessToken")) return;
      clearRefreshTimer();
      refreshTimerRef.current = window.setTimeout(() => {
        void runScheduledRefresh();
      }, MANDATE_STALE_MS);
    };

    const runScheduledRefresh = async () => {
      clearRefreshTimer();
      if (!localStorage.getItem("accessToken")) return;
      try {
        await fetchAndStoreMandateSession(
          dispatch,
          localStorage.getItem("role"),
        );
        await fetchAndPatchMandateSession(
          dispatch,
          localStorage.getItem("role"),
        );
      } catch (err) {
        console.error(err);
      } finally {
        scheduleNextFullMandateFetch();
      }
    };

    const bootstrap = async () => {
      if (!localStorage.getItem("accessToken")) {
        setDataSharingReady(true);
        return;
      }

      // 1) Data-sharing first — before any screen API
      try {
        await fetchAndStoreMandateSession(
          dispatch,
          localStorage.getItem("role"),
        );
      } catch (err) {
        console.error(err);
      } finally {
        setDataSharingReady(true);
      }

      // 2) Wait for screen APIs to start and all responses to complete
      try {
        await waitForScreenApisIdle();
      } catch (err) {
        console.error(err);
      }

      // 3) Remaining mandate only after screen API responses are received
      try {
        await fetchAndPatchMandateSession(
          dispatch,
          localStorage.getItem("role"),
        );
      } catch (err) {
        console.error(err);
      } finally {
        scheduleNextFullMandateFetch();
      }
    };

    void bootstrap();

    return () => clearRefreshTimer();
  }, [dispatch]);

  if (!dataSharingReady) return null;

  return <Router />;
};

export default App;
